<div class="d-inline-flex">
  <ncp-button
    #addMedicalReportButton
    [options]="btnOptions()"
  >
    <img
      [ngSrc]="assets.healthIcons.svg.outline.symbols.diagnostics.src"
      width="18"
      height="18"
      alt="Add Medical Report"
      class="healthIcon"
    />
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="medical_report_form"
      name="medical_report_form"
      [formGroup]="form"
      #frm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown
        #medicalCenterDD
        [(options)]="medicalCenterOptions"
      />

      <ncp-input [(options)]="authorInputOptions" />

      <ncp-dropdown
        #specialtyDD
        [(options)]="specialtyOptions"
      />

      <ncp-dropdown
        #hospitalizationDD
        [(options)]="hospitalizationOptions"
      />

      <ncp-date
        #onsetDate
        [(options)]="dateOptions"
      />

      <div>
        <label for="medicalReportFile" class="form-label">
          {{ 'input.labels.select_file' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          id="medicalReportFile"
          #documentFileInput
          type="file"
          class="form-control"
          accept="application/pdf"
          [formControl]="file"
          (change)="onFileSelected($event)"
        />
        @if(documentFileName) {
          <small class="text-muted">
            Selected: {{ documentFileName }}
          </small>
        }
      </div>
    </form>
  </ncp-modal>
</div>
